export default __webpack_public_path__ + "static/media/men.0bc2a8b8.svg";